export enum ContainerTypeEnum {
  Active = 'active',
  Available = 'available',
}
